<template>
  <div>
    <div class="q-toolbar">
      <div class="q-toolbar-buttons">
        <q-button
          class="q-toolbar-btn"
          :style="firstButtonStyle"
          @click="newModel"
        >
          <font-awesome-icon :icon="['fas', 'plus']"/>
        </q-button>
        <q-button
          v-if="getPermissions('DELETE')"
          v-show="hasSelection"
          class="q-toolbar-btn"
          @click="deleteDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'trash']"/>
        </q-button>

        <q-button
          class="q-toolbar-btn"
          @click.prevent="limitationDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'filter']"/>
        </q-button>
        <q-button
          class="q-toolbar-btn"
          @click="refreshRows"
        >
          <font-awesome-icon :icon="['fas', 'sync-alt']"/>
        </q-button>

        <q-input
          v-model="word"
          class="search-box"
          :placeholder="this.$qt('listStructure.searchPlaceHolder')"
          :style="searchStyle"
        >
          <q-button
            slot="append"
            type="info"
            icon="q-icon-search"
          />
        </q-input>
      </div>
    </div>

    <q-panel>
      <q-table
        stripe
        :data="filteredData"
        width="100%"
        sum-text="----"
        :empty-text="this.$qt('listStructure.emptyList')"
        @row-click="rowSelected"
        @selection-change="handleSelectionChange"
      >
        <q-table-column
          type="selection"
          width="55"
        />
        <q-table-column
          prop="title"
          :label="this.$qt('post.list.columns.title')"
        />
        <q-table-column
          prop="user"
          :label="this.$qt('post.list.columns.user')"
        />
        <q-table-column
          prop="category"
          :label="this.$qt('post.list.columns.category')"
        />
        <q-table-column
          prop="date"
          :label="this.$qt('post.list.columns.date')"
        />
        <q-table-column
          prop="commentQty"
          :label="this.$qt('post.list.columns.commentQty')"
        />


        <q-table-column
          align="left"
          width="180"
        >
          <template slot-scope="scope">
            <div class="q-toolbar-buttons">
              <q-button
                size="mini"
                @click="editPost(scope.$index, scope.row)"
              >
                <font-awesome-icon :icon="['fas', 'edit']"/>
              </q-button>

              <q-button
                size="mini"
                @click="deletePost(scope.$index, scope.row)"
              >
                <font-awesome-icon :icon="['fas', 'trash']"/>
              </q-button>
            </div>
          </template>
        </q-table-column>
      </q-table>

      <q-pagination
        :page-size="listStructure.itemInPage"
        :pager-count="11"
        :total="modelsQty"
        layout="prev ,pager , next"
        :current-page.sync="currentPage"
        :next-text="this.$qt('listStructure.pagination.nextText')"
        :prev-text="this.$qt('listStructure.pagination.prevText')"
        background
        @current-change="changePage"
      />
    </q-panel>

    <q-dialog
      :title="this.$qt('listStructure.limitationTitle')"
      width="50%"
      :visible.sync="limitationDialog"
      append-to-body
    >
      <div v-if="limitationStructure">
        <q-form
          ref="limitationForm"
          :model="rangeModel"
          :rules="rangeRules"
          labq-width="150px"
        >
          <q-form-generator
            v-model="rangeModel"
            :form-structure="limitationStructure"
          />
        </q-form>
      </div>
      <div v-else>
        <span>{{ this.$qt('listStructure.limitationNotSet') }}</span>
      </div>

      <span slot="footer">
        <q-button
          type="primary"
          @click="limit"
        >{{ this.$qt('listStructure.confirmLimitation') }}</q-button>
        <q-button @click="limitationDialog = false">{{ this.$qt('listStructure.rejectLimitation') }}</q-button>
      </span>
    </q-dialog>

    <q-dialog
      :title="this.$qt('model.deleteDialog.title')"
      :visible.sync="deleteDialog"
      width="30%"
      append-to-body
    >
      <span>{{ this.$qt('model.deleteDialog.warningNote') }}</span>
      <span
        slot="footer"
      >
        <q-button
          type="primary"
          @click="deleteModel()"
        >{{ this.$qt('model.deleteDialog.confirm') }}</q-button>
        <q-button @click="deleteDialog = false">{{ this.$qt('model.deleteDialog.cancel') }}</q-button>
      </span>
    </q-dialog>
  </div>
</template>

<script>

  import listMixin from '../../../q-components/mixins/listMixin';

  export default {
    name: "QPostList",

    mixins: [listMixin],

    props: {},
    data() {
      return {
        limitationDialog: false,
        limitationStructure: undefined,
        rangeModel: {},

        languages: [],

        updateCaption: this.$qt('model.updateButtonText')
      }
    },
    computed: {
      rangeRules() {
        let rules = {};
        if (!this.listStructure.limitationForm)
          return rules;
        for (let f in this.listStructure.limitationForm.properties) {
          let _field = this.listStructure.limitationForm.properties[f];
          let _rules = _field.rules;
          let fieldRules = [];
          for (let r in _rules) {
            fieldRules.push(_rules[r])
          }

          rules[_field.model] = fieldRules;
        }

        return rules;
      },
      searchStyle() {
        const ret = {};
        if (this.$isRtl)
          ret.marginRight = '5px';
        else
          ret.marginLeft = '5px';
        return ret;
      },
      firstButtonStyle() {
        const ret = {};
        if (this.$isRtl)
          ret.marginRight = '0';
        else
          ret.marginLeft = '0';
        return ret;
      },
    },
    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    },
    methods: {
      initialize() {
        this.$delegate('edms', 'getPostList', {
          range: null,
          itemInPage: 10,
          page: 1
        }).then((res) => {
          this.models = res.result.posts;
          this.pageQty = res.result.pageQty;
          this.modelsQty = res.result.itemsQty;
          this.currentPage = 1;
          this.rangeModel = {};

          this.$eventHub.$emit("onPageChanging", {
            caption: 'this.formStructure.caption',
            note: 'this.formStructure.note'
          })
        }).catch(() => {
        });
      },

      refreshRows() {
        this.rangeModel = {};
        this.$delegate('edms', 'getPostList', {
          range: this.rangeModel,
          itemInPage: 10,
          page: 1
        }).then((res) => {
          this.limitationDialog = false;
          this.currentPage = 1;
          this.models = res.result.posts;
          this.pageQty = res.result.pageQty;
          this.modelsQty = res.result.itemsQty;
        }).catch(() => {
        });
      },

      limit() {
        this.$delegate('edms', 'getPostList', {
          range: this.rangeModel,
          itemInPage: 10,
          page: 1
        }).then((res) => {
          this.limitationDialog = false;
          this.currentPage = 1;
          this.models = res.result.posts;
          this.pageQty = res.result.pageQty;
          this.modelsQty = res.result.itemsQty;
        }).catch(() => {
        });
      },
      changePage() {
        this.$delegate('edms', 'getPostList', {
          range: this.rangeModel,
          itemInPage: 10,
          page: this.currentPage
        }).then((res) => {
          this.limitationDialog = false;
          this.models = res.result.posts;
          this.pageQty = res.result.pageQty;
          this.modelsQty = res.result.itemsQty;
        }).catch(() => {
        });
      },
      rowSelected() {
      },
      newModel() {
        let params = {
          structureKey: 'postDetail',
          detailKey: 'NEW'
        };
        this.$router.push({
          name: 'postDetail', params: params
        });
      },

      editPost(index, row) {
        let params = {
          postId: row.id
        };
        this.$router.push({
          name: 'editPost', params: params
        });
      },
      deletePost(index, row) {
        this.$confirm(this.$qt('model.deleteDialog.warningNote'), this.$qt('model.deleteDialog.title'), {
          confirmButtonText: this.$qt('model.deleteDialog.confirm'),
          cancelButtonText: this.$qt('model.deleteDialog.cancel'),
          type: 'warning'
        }).then(() => {
          this.$delegate('edms', 'deletePost', {
            id: row.id
          }).then((res) => {
            this.$notify({
              title: this.$qt('model.deleteDialog.successMessage'),
              message: res.message,
              type: 'success'
            });
            this.$message({
              type: 'success',
              message: this.$qt('model.deleteDialog.successMessage')
            });
            this.deleteDialog = false;
            const index = this.models.findIndex(d => d.id === row.id);
            this.models.splice(index, 1);

          }).catch((err) => {
            this.$message({
              type: 'info',
              message: err
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$qt('model.deleteDialog.cancelMessage')
          });
        });
      }
    }
  }
</script>

<style scoped>
  .q-toolbar {
    margin: 20px;
  }

  .q-toolbar-buttons {
    display: -webkit-box;
    display: -ms-flexbox;

    display: flex;
    line-height: 15px;
  }

  .q-toolbar-btn {
    margin-left: 3px;
    margin-right: 3px;
  }

  .search-box {
    width: 70%
  }
</style>